import { loadStripe } from "@stripe/stripe-js";

/**
 * This is a singleton to ensure we only instantiate Stripe once.
 */
let stripePromise: any = null;
const getStripe = async (locale = "en", isUnsecure: boolean) => {
  if (stripePromise) {
    return stripePromise;
  }
  if (isUnsecure) {
    return null;
  }
  try {
    stripePromise = await loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY, { locale, canCreateRadarSession: true });
    return stripePromise;
  } catch (err) {
    console.error("Stripe Loading failed", err);
  }
  return stripePromise;
};

export default getStripe;
